import { createRequest } from '@savgroup-front-common/core/services/request';

export const LOAD_OWNER_INFO = createRequest('MARKETPLACE/LOAD_OWNER_INFO');

export const LOAD_OWNER_PRODUCTS = createRequest('LOAD_OWNER_PRODUCTS');
